export enum DownloadExcelType {
  excel,
  accreditation,
  accessori,
}
